import React from 'react';

import styled from 'styled-components';

import { useAppSelector } from 'store/hook';

import Map from '../../common/Widgets/Map/Map';

const Container = styled.div`
  position: relative;
  overflow-y: hidden;
  border-radius: 10px;
`;

const OverviewMap = () => {
  const { communities, competitors } = useAppSelector((state) => state.global);

  return (
    <Container>
      <Map communities={communities} competitors={competitors} />
    </Container>
  );
};

export default OverviewMap;
